import React, { useState, useEffect } from 'react';
import './ComplaintModal.css';
import { motion, AnimatePresence } from 'framer-motion';
import { Primary,Secondary } from '../Constants/Colours';
import Which from '../Images/HomePageImages/Which.png';
import eventEmitter from '../../Utils/EventEmitter';


function ComplaintModal() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible((prev) => !prev);
    };

    eventEmitter.on('toggleComplaintModal', toggleVisibility);

    return () => {
      eventEmitter.off('toggleComplaintModal', toggleVisibility);
    };
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div 
          key="complaint-modal"
          initial={{ opacity: 0 }} 
          animate={{ opacity: 1 }} 
          exit={{ opacity: 0 }} 
          className="Complaint-Modal-Background"
          onClick={() => setIsVisible(false)}
        >
          <motion.div 
            initial={{ opacity: 0, scale: 0.8 }} 
            animate={{ opacity: 1, scale: 1 }} 
            exit={{ opacity: 0, scale: 0.8 }} 
            className="Complaint-Modal-Content"
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{backgroundColor:Secondary}}  className="Complaint-Modal-Content-Header">
                <h1>Complaints Policy</h1>
            </div>
            <div className="Complaint-Modal-Content-Body">
                <h1><span>COMPLAINTS POLICY</span><br/>
    The business always endeavours to provide the best service.  However, on rare occasions there may be times where a customer may not be completely satisfied. 
    <br/><br/>To ensure the business can put things right for you, as soon as possible after the completion of the works, please inspect the work to ensure everything has been carried out based on the contract terms and to the high standards the business aims to achieve.
    <br/><br/>Please contact the business straight away with any concerns either by phone, email or write to us. If writing, get proof of posting.
    <br/><br/><span>Business Complaint Procedure</span><br/><br/>
    On receipt of your complaint the business aims to respond within 5 days. <br/> 
    <br/><br/>The business will arrange a convenient date to come and view and/or remedy the situation within 28 days.
    <br/><br/>In the unlikely event the business is unable to resolve your complaint having exhausted the business complaints procedure, it may be necessary to use another complaint service.  Where the business cannot resolve the complaint to your satisfaction and/or agree to the final resolution requests confirmed to us; and both parties agree a ‘deadlock’ has been reached, you can then escalate your complaint.
    <br/><br/>The business has access to an Alternative Dispute Resolution (ADR) service for our domestic installation, service, repair and maintenance contracts as part of the Which? Trusted Traders Endorsement.  If you choose to you can refer your complaint to Which? Trusted Traders’ Alternative Dispute Resolution.  You will need to contact Which? Trusted Traders on 02922 670 040 who can explain if you are eligible to use their Alternative Dispute Resolution.</h1>
                <img style={{height:'100px',width:'auto',alignSelf:'flex-end',paddingRight:'70px'}} src={Which}/>
            </div>
            
          </motion.div>
         
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default ComplaintModal;